export default __webpack_public_path__ + "static/media/ots-rentacar-logo.3c70e08b.png";